import httpClient from "@/services/httpClient";
import { server, trademark_const } from "@/services/constants";

export const getOCRKW = () => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.OCRKW + `/`);
};
export const getOCRKWList = () => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.OCRKW + `/gatorckwlist`);
};
export const getOCRKWListCon = (doctype_id, notice_id) => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.OCRKW + `/gatorckwlistcon/${doctype_id}/${notice_id}`);
};
export const createOCRKW = (data) => {
    return httpClient.post(`${trademark_const.trademark_url}/` + server.OCRKW + `/create`, data);
};

export const updateOCRKW = (id, data) => {
    return httpClient.put(`${trademark_const.trademark_url}/` + server.OCRKW + `/${id}`, data);
};
export const deleteOCRKW = (id) => {
    return httpClient.delete(`${trademark_const.trademark_url}/` + server.OCRKW + `/delete/${id}`);
};

